<div *ngIf="updatedActivity">
  <div class="icon">
    <mat-icon>{{ updatedActivity.icon }}</mat-icon>
  </div>
  <div>
    <div class="description">
      <strong>{{ updatedActivity.title }}</strong>
      {{ updatedActivity.content }}

      <a href="javascript:" *ngIf="activity.meta.changes || activity.meta.detailContent" (click)="showDiff = !showDiff">
        <span *ngIf="!showDiff">Show</span><span *ngIf="showDiff">Hide</span> all updates
      </a>
      <a href="javascript:" *ngIf="activity.meta.reason" (click)="showDiff = !showDiff">
        <span *ngIf="!showDiff">Show</span><span *ngIf="showDiff">Hide</span> reason
      </a>

      <span *ngIf="updatedActivity.link">
        <a [href]="updatedActivity.link.href || '#'" matTooltip="{{updatedActivity.link.tooltip}}">
          {{ updatedActivity.link.title }}
        </a>
      </span>
      <div *ngIf="activity.meta.changes && showDiff" class="profile-change-container">
        <div class="change" *ngFor="let change of (activity.meta.changes | keyValues)">
          <strong>{{ activity.meta.lenderUserName }} updated </strong>
          <span *ngIf="change.value.original">
            {{ change.key | statusDisplay }} from
            <span class="original">"{{ change.value.original }}"</span>
            to "{{ change.value.new }}"
          </span>
          <span *ngIf="!change.value.original">
            {{ change.key | statusDisplay }} to {{ change.value.new }}
          </span>
        </div>
        {{ updatedActivity.diff | json }}
      </div>

      <document-pill
        *ngIf="activity.type === 'document' || activity.type === 'lenderDocument' || activity.type === 'documentPushedToFlashSpread'"
        class="ml-2"
        [filename]="activity.meta.title || activity.meta.filename || activity.meta.name"
        [bytes]="activity.meta.size"
      ></document-pill>

    </div>
    <div *ngIf="activity.type === 'documentNameChange' ">
      Document <strong>{{ activity.meta.oldFilename}}</strong> renamed to <strong>{{activity.meta.filename}}</strong> by {{activity.meta.initiatorName}}
    </div>

    <div *ngIf="(activity.meta.detailContent || activity.meta.detailHref) && showDiff" class="profile-change-container">
        <span>{{ activity.meta.detailContent }}</span>
        <span *ngIf="activity.meta.detailHref && showDiff">
          - <a [href]="activity.meta.detailHref" target="_blank">
                {{ activity.meta.detailHrefLabel ||  activity.meta.detailHref }}
            </a>
        </span>
    </div>

    <div *ngIf="activity.meta.reason && showDiff" class="profile-change-container">
      <strong *ngIf="activity.meta.reason !=='Explain' && activity.meta.reason !=='Other'">
        <span>{{ activity.meta.reason }}</span>
      </strong>
      <span *ngIf="activity.meta.otherReason">{{ activity.meta.otherReason }}</span>
    </div>

    <!-- description -->
  </div>
</div>
